<template>
  <div>
    <v-dialog max-width="1200" persistent scrollable v-model="whatsAppTemplatePicker">
      <v-card class="whatsapp-template-picker">
        <v-card-title class="headline">
          <span>Importar modelo do WhatsApp</span>

          <v-spacer></v-spacer>

          <v-btn @click="whatsAppTemplatePicker = false" icon title="Fechar">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider class="ma-0"></v-divider>

        <v-card-text>
          <qj-list-template-whatsApp
            :template-selected="importWhatsAppTemplate"></qj-list-template-whatsApp>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      scrollable
      v-model="dialogModel"
      width="650px"
      @keydown.esc="close"
      persistent>
      <v-card v-if="newInitiativeDialog">
        <v-card-title class="headline" primary-title>
          <span>{{
            initiative.id
              ? `Editar Iniciativa #${initiative.id} - ${initiative.key}`
              : "Nova Iniciativa"
          }}</span>

          <v-spacer></v-spacer>

          <v-btn
            @click="whatsAppTemplatePicker = true"
            color="green"
            dark
            depressed
            title="Importar modelo do WhatsApp">
            <v-icon left>mdi-whatsapp</v-icon>
            Importar modelo
          </v-btn>
        </v-card-title>
        <v-divider class="ma-0"></v-divider>
        <v-card-text class="initiativeDialog">
          <v-alert
            :value="importedTemplate"
            dismissible
            transition="scale-transition"
            type="warning">
            Não se esqueça de revisar os parâmetros na mensagem, cabeçalhos e botões
          </v-alert>

          <v-form ref="form">
            <v-container fluid>
              <v-layout row wrap>
                <v-flex xs8>
                  <v-text-field
                    box
                    v-model="initiative.name"
                    label="Nome*"
                    :rules="nameRules"
                    name="name"
                    @input="autofillScopeAndType"
                    ></v-text-field>
                </v-flex>
                
                <v-flex xs4>
                  <v-select
                    box
                    :items="scopeTypes"
                    item-text="name"
                    item-value="value"
                    v-model="initiative.scope"
                    label="Escopo*"
                    name="scope"
                    required
                    ></v-select>
                </v-flex>

                <v-flex xs12 md6>
                  <v-text-field
                    box
                    v-model="initiative.key"
                    label="Chave*"
                    name="key"
                    @input="autofillScopeAndType"
                    :rules="keyRules"></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-select
                    box
                    :items="metaCategoryTypes"
                    item-text="name"
                    item-value="value"
                    v-model="initiative.meta_category"
                    label="Categoria*"
                    name="meta_category"
                    :rules="metaRules"
                    :disabled="!!initiative.id || importedTemplate"></v-select>
                </v-flex>

                <v-switch
                  class="ml-2 mt-0"
                  label="Permitir envio quando a categoria for Marketing"
                  v-model="initiative.allow_marketing">
                </v-switch>

                <v-flex xs12 md12>
                  <v-radio-group
                    v-model="initiative.type"
                    row
                    class="mt-2">
                    <template v-slot:label>
                      <div class="mr-4"><strong>Tipo de template:</strong></div>
                    </template>
                    <v-radio
                      label="Normal"
                      value="NORMAL"
                      color="primary"></v-radio>
                    <v-radio
                      label="Flow"
                      value="FLOW"
                      color="primary"></v-radio>
                  </v-radio-group>
                </v-flex>

                <v-flex xs12 md6>
                  <v-select
                    box
                    clearable
                    :items="creditors"
                    item-text="name"
                    item-value="creditor_id"
                    v-model="initiative.creditor_id"
                    label="Credor"
                    name="creditor"
                    @click:clear="initiative.creditor_id = null">
                    <template v-slot:selection="{ item }">
                      <span style="width: 100%">
                        {{ "#" + item.creditor_id + " - " }}
                        {{ item.name }}
                      </span>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-tile-content style="width: 100%">
                        {{ "#" + item.creditor_id + " - " }}
                        {{ item.name }}
                      </v-list-tile-content>
                    </template>
                  </v-select>
                </v-flex>

                <v-flex xs12 md6>
                  <v-select
                    box
                    clearable
                    :items="phone_senders"
                    v-model="initiative.phone_sender_id"
                    label="Sender*"
                    name="sender"
                    item-value="id"
                    @click:clear="initiative.phone_sender_id = null"
                    :disabled="!!initiative.id || importedTemplate"
                    :rules="requiredRule">
                    <template v-slot:selection="{ item }">
                      <p style="width: 100%">
                        <span>
                          {{ item.phone_number | phoneNumber }}
                          <FlaggedIcon
                            v-if="
                              item.meta_status && item.meta_status === 'FLAGGED'
                            "
                          ></FlaggedIcon>
                        </span>

                        <v-tooltip v-if="item.meta_quality_rating_v2" bottom>
                          <template v-slot:activator="{ on }">
                            <span
                              v-on="on"
                              class="initiative_selector_sender--status"
                              :class="[item.meta_quality_rating_v2]">
                              {{ item.meta_quality_rating_v2 | whatsappSenderQuality }}
                            </span>
                          </template>
                          <span>Qualidade</span>
                        </v-tooltip>
                      </p>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-tile-content style="width: 100%">
                        <p style="width: 100%">
                          <span>
                            {{ item.phone_number | phoneNumber }}
                            <FlaggedIcon
                              v-if="
                                item.meta_status && item.meta_status === 'FLAGGED'
                              "
                            ></FlaggedIcon>
                          </span>
                          <v-tooltip v-if="item.meta_quality_rating_v2" bottom>
                            <template v-slot:activator="{ on }">
                              <span
                                v-on="on"
                                class="initiative_selector_sender--status"
                                :class="[item.meta_quality_rating_v2]">
                                {{ item.meta_quality_rating_v2 | whatsappSenderQuality }}
                              </span>
                            </template>
                            <span>Qualidade</span>
                          </v-tooltip>
                        </p>
                      </v-list-tile-content>
                    </template>
                  </v-select>
                </v-flex>

                <v-flex xs12 md12>
                  <v-textarea
                    box
                    auto-grow
                    v-model="initiative.description"
                    label="Descrição"
                    name="description"
                    counter="256"
                    :maxlength="256"
                    rows="1"></v-textarea>
                </v-flex>

                <h3 class="mt-2">Cabeçalho</h3>
                <v-flex xs12 md12>
                  <v-select
                    clearable
                    box
                    :items="headerTypes"
                    item-text="name"
                    item-value="value"
                    v-model="initiative.header_type"
                    label="Tipo de cabeçalho"
                    name="header_type"
                    disabled
                    readonly></v-select>
                </v-flex>
                <v-flex xs12 md12 @drop="dragFile" @dragover.prevent v-if="initiative.header_type">
                  <v-text-field
                    label="Solte aqui o arquivo ou selecione-o"
                    @click="onPickFile"
                    v-model="initiative.header_text"
                    prepend-icon="attach_file"
                    clearable
                    box
                    :rules="headerTextRules">
                    <template v-slot:append-outer>
                      <v-btn
                        :href="initiative.header_text"
                        class="ma-0"
                        flat
                        icon
                        target="_blank"
                        title="Visualizar"
                        v-if="initiative.header_text"
                        v-model="initiative.header_text">
                        <v-icon>open_in_new</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                  <input
                    type="file"
                    style="display: none"
                    ref="fileInput"
                    accept="*/*"
                    @change="dragFile"
                    :rules="headerTextRules" />
                </v-flex>

                <h3 class="mt-1">Corpo</h3>
                <v-flex xs12 md12>
                  <v-alert
                    :value="importedTemplate"
                    dismissible
                    transition="scale-transition"
                    type="warning">
                    Substitua os parâmetros que estão entre <code>&#123;&#123;</code> e
                    <code>&#125;&#125;</code> pelo nome da variável.
                    <br />
                    Por exemplo, no lugar de
                    <code>{{ whatsAppTemplateImportedAlertExample }}</code> você pode usar
                    <code>$NAME</code> ou qualquer outra variável.
                  </v-alert>

                  <textAreaAutocomplete
                    name="message1"
                    label="Mensagem*"
                    :message="initiative.message"
                    :variables="allowedVariables"
                    @message="initiative.message = $event" />
                </v-flex>
                <v-switch
                  hide-details
                  class="mb-1 mt-0 pt-0"
                  label="Mostrar mais variáveis"
                  v-model="switchShow">
                </v-switch>

                <v-flex md12 class="mb-3" style="overflow: auto; border: 1px solid #cccccc">
                  <div class="var-container">
                    <v-chip
                      :key="`${k}`"
                      v-for="(variable, k) in allowedVariables"
                      v-show="switchShow ? true : variable.show"
                      class="var-content"
                      :class="{ selected: variable.selected }"
                      @click="varClick(variable.name)">
                      <small>
                        <strong>{{ variable.name }}</strong>
                        <br />
                        <small style="margin-top: -2px; font-size: 10px">
                          {{ variable.label }}
                        </small>
                      </small>
                    </v-chip>
                  </div>
                </v-flex>

                <v-flex xs12 md12>
                  <v-textarea
                    box
                    auto-grow
                    v-model="initiative.footer_text"
                    label="Texto do footer"
                    counter="60"
                    :maxlength="60"
                    name="footer_text"
                    rows="1"></v-textarea>
                </v-flex>

                <h3 class="mt-1">Botões</h3>
                <v-flex v-if="initiative.buttons" xs12 md12>
                  <div v-for="(button, index) in initiative.buttons" :key="index">
                    <v-select
                      box
                      clearable
                      :items="buttonsType"
                      item-text="name"
                      item-value="value"
                      v-model="button.type"
                      label="Tipo do botão"
                      name="button_type"
                      disabled
                      readonly
                      :rules="requiredRule"></v-select>

                    <v-flex xs12 md12 v-if="button.type == 'FLOW'">
                      <v-text-field
                        box
                        class="mr-2"
                        disabled
                        label="Texto do botão"
                        prepend-icon="text_snippet"
                        readonly
                        v-model="button.text"></v-text-field>
                    </v-flex>

                    <v-flex xs12 md12 v-if="button.type == 'URL'">
                      <v-text-field
                        box
                        :maxlength="30"
                        counter="30"
                        class="mr-2"
                        label="Texto do botão*"
                        prepend-icon="open_in_new"
                        v-model="button.text"
                        :rules="linkButtonTextRules"></v-text-field>
                      <v-select
                        box
                        clearable
                        :items="buttonLinkType"
                        item-text="name"
                        item-value="value"
                        v-model="button.link_type"
                        label="Link a ser enviado"
                        name="button_type"
                        prepend-icon="open_in_new"
                        :rules="requiredRule"></v-select>
                    </v-flex>

                    <v-flex xs12 md12 v-if="button.type == 'QUICK_REPLY'">
                      <v-text-field
                        box
                        :maxlength="20"
                        counter="20"
                        class="mr-2"
                        label="Texto do botão*"
                        prepend-icon="reply"
                        v-model="button.text"
                        :rules="buttonTextRules"></v-text-field>
                      <v-text-field
                        box
                        :maxlength="128"
                        counter="128"
                        class="mr-2"
                        label="Parâmetros"
                        prepend-icon="reply"
                        hint="Parâmetro que será enviado quando o usuário clicar no botão. Para o botão 'Quero negociar' informe sempre quero_negociar"
                        persistent-hint
                        v-model="button.parameter"></v-text-field>
                    </v-flex>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>

        <v-divider class="ma-0"></v-divider>

        <v-card-actions>
          <v-btn color="blue lighten-1" text outline dark @click="openPreviewDialog()"
            >Visualizar</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="primary" outline dark @click="close()">Cancelar</v-btn>
          <v-btn color="accent" @click="save()">
            {{ initiative.id ? "Salvar" : "Confirmar" }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <InitiativePreview ref="InitiativePreview" :previewDialog.sync="previewDialog">
      </InitiativePreview>
    </v-dialog>
  </div>
</template>

<script>
import QjListTemplateWhatsApp from "@/components/QjListTemplateWhatsApp";
import SelectCreditors from "@/components/creditor/SelectCreditors";
import InitiativePreview from "./Preview/Preview";
import textAreaAutocomplete from "@/components/TextAreaAutocomplete";
import utilsVariables from "@/utils/message-variables";
import FlaggedIcon from "@/components/ui/FlaggedIcon.vue";

import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  props: ["newInitiativeDialog", "creditors", "phone_senders", "isContentApprover"],

  components: {
    SelectCreditors,
    InitiativePreview,
    textAreaAutocomplete,
    FlaggedIcon,
  },
  data() {
    return {
      keyMask: /^[a-zA-Z0-9_]+$/,
      previewDialog: false,
      whatsAppTemplatePicker: false,
      importedTemplate: false,
      whatsAppTemplateImportedAlertExample: "{{1}}",
      initiative: {
        id: null,
        name: null,
        key: null,
        creditor_id: null,
        meta_category: null,
        description: null,
        header_type: null,
        header_text: null,
        message: null,
        footer_text: null,
        buttons: null,
        phone_sender_id: null,
        type: "NORMAL",
      },
      variables_array: [],
      allowedVariables: [],
      switchShow: false,
      metaCategoryTypes: [
        { value: "MARKETING", name: "Marketing" },
        { value: "UTILITY", name: "Utilidade" },
        { value: "AUTHENTICATION", name: "Autenticação" },
      ],
      headerTypes: [
        { value: "IMAGE", name: "Imagem" },
        { value: "VIDEO", name: "Vídeo" },
      ],
      buttonsType: [
        { value: "FLOW", name: "WhatsApp Flows" },
        { value: "QUICK_REPLY", name: "Resposta rápida" },
        { value: "URL", name: "Link" },
      ],
      buttonLinkType: [
        { value: "link", name: "Negociação" },
        { value: "link_creditor", name: "Credor do estímulo" },
        { value: "link_unsubscribe", name: "Descadastrar" },
        { value: "link_redirect", name: "Link de redirecionamento" },
      ],
      scopeTypes: [
        { value: "FIRING", name: "Disparos" },
        { value: "INCENTIVE", name: "Incentivos" },
      ],

      // VALIDAÇÔES
      nameRules: [
        (v) => !!v || "Nome em branco",
        (v) => (v && v.length < 256) || "Nome contem muitos caracteres",
      ],
      keyRules: [
        (v) => !!v || "Chave em branco",
        (v) => (v && v.length < 256) || "Chave contem muitos caracteres",
        (v) =>
          this.keyMask.test(v) ||
          "Apenas underscore (sublinhado) é permitido como caractere especial",
      ],
      metaRules: [(v) => !!v || "Categoria em branco"],
      messageRules: [
        (v) => !!v || "Mensagem em branco",
        (v) => (v && v.length < 4024) || "Mensagem contem muitos caracteres",
      ],
      headerTextRules: [
        (v) => {
          if (this.initiative.header_type) {
            return !!v || "Link do arquivo em branco!";
          } else {
            return true;
          }
        },
      ],
      buttonTextRules: [
        (v) => {
          if (!v) {
            return "Texto do botão em branco!";
          }
          if (v.length > 20) {
            return "Texto do botão muito longo!";
          }
          return true;
        },
      ],
      linkButtonTextRules: [
        (v) => {
          if (!v) {
            return "Texto do botão em branco!";
          }
          if (v.length > 30) {
            return "Texto do botão muito longo!";
          }
          return true;
        },
      ],
      requiredRule: [
        (v) => {
          if (!v) {
            return "Campo em branco!";
          }
          return true;
        },
      ],
    };
  },
  mounted() {
    this.variables_array = utilsVariables.variables;
  },
  computed: {
    dialogModel: {
      get() {
        return this.newInitiativeDialog;
      },
      set(value) {
        this.$emit("update:newInitiativeDialog", value);
      },
    },
    ...mapGetters("initiativeManager", {
      selectedInitiative: "selectedInitiative",
    }),
    selectedVars() {
      if (!this.initiative.message) return [];

      // Captura $VAR
      const regex = /\$\w+/g;
      const matches = this.initiative.message.match(regex) || [];

      // Remove duplicatas e $
      const uniqueMatches = [...new Set(matches)].map((v) => v.slice(1));

      // Apenas as que estão na lista permitida
      const allowedNames = this.allowedVariables.map((v) => v.name);
      return uniqueMatches.filter((v) => allowedNames.includes(v));
    },
  },
  methods: {
    ...mapMutations("initiativeManager", {
      setSelectedInitiative: "setSelectedInitiative",
      clearSelectedInitiative: "clearSelectedInitiative",
    }),
    ...mapActions("initiativeManager", {
      createInitiative: "createInitiative",
      editInitiative: "editInitiative",
      createInitiativeMedia: "createInitiativeMedia",
      uploadInitiativeMedia: "uploadInitiativeMedia",
    }),

    async dragFile(event) {
      event.preventDefault();
      let file = null;
      if (event.dataTransfer) {
        file = event.dataTransfer.files[0];
      } else {
        file = event.target.files[0];
      }
      await this.uploadArchive(file);
    },

    onPickFile() {
      this.$refs.fileInput.click();
    },

    async uploadArchive(file) {
      const payload = {
        info: [
          {
            content_type: file.type,
            size: file.size,
            name: file.name,
            type: file.type,
          },
        ],
        type: ["whatsapp", "initiatives"],
      };

      const s3 = await this.createInitiativeMedia(payload);

      await this.uploadToS3(s3, file);
    },

    async uploadToS3(s3, fileData) {
      const data = this.createS3UploadForm(s3._storage, fileData);
      const params = {
        url: s3._storage.url,
        data,
      };

      await this.uploadInitiativeMedia(params);
      this.initiative = { ...this.initiative, header_text: s3.url };
    },

    createS3UploadForm(storage, file) {
      let formData = new FormData();
      formData.append("Content-Type", storage.fields["Content-Type"]);
      formData.append("key", storage.fields.key);
      formData.append("AWSAccessKeyId", storage.fields.AWSAccessKeyId);
      formData.append("acl", storage.fields.acl);
      formData.append("policy", storage.fields.policy);
      formData.append("signature", storage.fields.signature);
      formData.append("file", file);
      return formData;
    },

    close() {
      this.clearSelectedInitiative();
      this.$emit("update:newInitiativeDialog", false);
      this.importedTemplate = false;
    },

    save() {
      if (!this.$refs.form.validate()) {
        this.$store.commit("showSnackbar", {
          important: true,
          message: "Verifique os campos obrigatórios",
        });
        return; 
      }

      const message = this.initiative.message || "";

      this.initiative.vars = this.allowedVariables
        .filter((v) => v.selected && message.includes(v.name))
        .sort((a, b) => message.indexOf(a.name) - message.indexOf(b.name))
        .map((v) => v.name.replace(/^\$/, ""));

      this.setSelectedInitiative(this.initiative);

      if (this.initiative.id) {
        // edição:
        this.editInitiative(this.initiative);
        this.close();
      } else {
        // criação:
        this.createInitiative().then((newInitiative)=>{
          if (this.importedTemplate && this.isContentApprover) {
            // se for um template importado e o usuário tiver permissão de aprovar,
            // tenta aprovar automaticamente
            this.setSelectedInitiative(newInitiative);
            this.$emit("autoapprove", newInitiative);
            this.$emit("update:newInitiativeDialog", false);
          } else {
            router.go()
          }
        });
      }
    },

    openPreviewDialog() {
      this.setSelectedInitiative(this.initiative);
      this.previewDialog = true;
    },

    updateSelectedVars() {
      if (!this.initiative.message) {
        this.initiative.vars = [];
        this.allowedVariables.forEach((v) => (v.selected = false));
        return;
      }

      const message = this.initiative.message;

      const sortedVars = [...this.allowedVariables].sort((a, b) => b.name.length - a.name.length);

      const foundVars = [];

      sortedVars.forEach((v) => {
        const regex = new RegExp(`\\$${v.name}(?=\\s|$)`, "g");

        if (regex.test(message)) {
          foundVars.push(v.name);
          v.selected = true;
        } else {
          v.selected = false;
        }
      });

      this.initiative.vars = foundVars.sort(
        (a, b) => message.indexOf(`$${a}`) - message.indexOf(`$${b}`)
      );
    },

    varClick(name) {
      if (!name) return;
      if (!this.initiative.message) this.$set(this.initiative, "message", "");

      const sp = this.initiative.message.endsWith(" ") || this.initiative.message === "" ? "" : " ";
      const value = `${sp}${name}`;

      this.$set(this.initiative, "message", this.initiative.message + value);
      this.updateSelectedVars();
    },

    getAllowedVariables() {
      let vars_ = [];
      this.creditors.forEach((el) => {
        if (el.creditor_id == this.initiative.creditor_id) {
          vars_ = vars_.concat(el.allowed_variables);
        }
      });

      if (!vars_.length) {
        this.allowedVariables = this.variables_array;
      } else {
        if (typeof vars_[0] === "string") {
          vars_ = this.variables_array.filter((item) => vars_.includes(item.name));
        } else {
          this.allowedVariables = vars_;
        }
      }
    },
    /** Importa o modelo que está na Infobip. */
    importWhatsAppTemplate(template, phone_sender) {
      this.whatsAppTemplatePicker = false;
      this.importedTemplate = true;

      if (!template) return;

      // Mapeamento básico
      const { category, name, id, quality, status, structure } = template;
      this.initiative = {
        ...this.initiative,
        allow_marketing: category === "MARKETING",
        key: name,
        meta_category: category || null,
        meta_id: id || null,
        phone_sender_id: phone_sender.id || null,
        meta_quality_score: quality || null,
        meta_status: status || null,
      };

      // Corpo da mensagem
      this.initiative.message = (structure && structure.body && structure.body.text) || null;

      // Botões
      this.$set(this.initiative, "buttons", []);

      if (Array.isArray(structure && structure.buttons) && structure.buttons.length > 0) {
        structure.buttons.forEach((btn, idx) => {
          const buttonData = {
            text: btn.text || "",
            type: btn.type || "",
            link_type: null,
            parameter: btn.parameter || "",
          };

          // https://github.com/quiteja/quiteja-chatbot-async/blob/f3d6b2830da47b7eba057e42d95a5e67d417fd72/quiteja_chatbot_async/message.py#L120
          if (buttonData.text.toLowerCase() == "quero negociar") {
            buttonData.parameter = "quero_negociar";
          }

          this.$set(this.initiative.buttons, idx, buttonData);
        });
      }

      // Cabeçalho
      if (structure && structure.header && structure.header.format) {
        this.initiative.header_type = structure.header.format;
      } else {
        this.initiative.header_type = null;
      }

      // Footer
      if (structure && structure.footer) {
        this.initiative.footer_text = structure.footer.text;
      } else {
        this.initiative.footer_text = null;
      }

      this.autofillScopeAndType();
    },
    autofillScopeAndType() {
      if (this.initiative.id) return;

      // Se tiver 'incen' no nome ou na key seleciona 'INCENTIVE' no Escopo
      if (
        (this.initiative.key &&
          this.initiative.key.toLowerCase().includes("incen")) ||
        (this.initiative.name &&
          this.initiative.name.toLowerCase().includes("incen"))
      ) {
        this.initiative.scope = "INCENTIVE";
      }

      // Se tiver 'flow' no nome ou na key seleciona 'FLOW' no tipo de template
      if (
        (this.initiative.key &&
          this.initiative.key.toLowerCase().includes("flow")) ||
        (this.initiative.name &&
          this.initiative.name.toLowerCase().includes("flow"))
      ) {
        this.initiative.type = 'FLOW'
      }
    },
  },

  watch: {
    "initiative.header_type"(newValue) {
      if (!newValue) {
        this.initiative.header_text = null;
        this.initiative.header_type = null;
      }
    },
    "initiative.footer_text"(newValue) {
      if (!newValue) {
        this.initiative.footer_text = null;
      }
    },
    "initiative.message"(newMessage) {
      this.updateSelectedVars();
    },
    "initiative.creditor_id"() {
      this.getAllowedVariables();
      this.updateSelectedVars();
    },
    newInitiativeDialog(newValue) {
      if (newValue) {
        this.getAllowedVariables();

        this.initiative = Object.assign({}, this.selectedInitiative);
        
        if (!this.initiative.type) {
          this.initiative.type = "NORMAL";
        }

        if (!this.initiative.scope) {
          this.initiative.scope = "FIRING";
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
h3 {
  margin: 15px 0;
  width: 100%;
  color: #666;
  // border-bottom: 1px solid;
  text-align: left;
}
.var-container {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;

  .selected {
    background-color: #4caf50;
    color: white;
  }
}
.initiativeDialog {
  overflow-y: auto !important;
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px rgb(192, 189, 189);
    border-radius: 10px;
  }
  &::-webkit-scrollbar {
    width: 5px;
    height: 30px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #bdbdbd;
    border-radius: 20px;
  }
}

.whatsapp-template-picker {
  .v-card__text {
    height: 90vh;
    padding: 0 !important;
  }
}
</style>
